import PropTypes from "prop-types";

import { strCode } from "../../../consts";
import { formatUtils } from "./utils/formatUtils";

import {
  BatchCreate,
  Checkbox,
  FlexContainers,
  TooltipIcon,
  WrapperContainer
} from "../../../components";
import { ImportedDevicesTableColumns } from "./ImportedDevicesTableColumns";

import deviceTemplate from "../../../assets/files/deviceTemplate.csv";
import { useCallback, useMemo, useState } from "react";
import { CheckboxLabel } from "../../../components/Checkbox/styled";
import { t } from "../../../services";

const DeviceBatchCreateModal = ({ active, setActive, onSubmit }) => {
  const [generateCertificates, setGenerateCertificates] = useState(true);

  const handleSubmit = useCallback(
    async (file, data) => {
      await onSubmit(file, data, generateCertificates);
    },
    [generateCertificates, onSubmit]
  );

  return (
    <BatchCreate
      active={active}
      setActive={setActive}
      csvExampleName={"deviceTemplate"}
      csvExampleUrl={deviceTemplate}
      successInfo={strCode.SUCCESSFUL_DEVICES_IMPORT_INFO}
      failedInfo={strCode.FAILED_DEVICES_IMPORT_INFO}
      onSubmit={handleSubmit}
      formatParsedData={formatUtils.formatParsedData}
      formatRecords={formatUtils.formatRecords}
      ImportedRecordsTableColumns={ImportedDevicesTableColumns}
      SuccessImportActions={({ records }) => {
        const hasMercuryDevices = useMemo(() => records?.some((x) => x.isMercuryDevice), [records]);

        return (
          hasMercuryDevices && (
            <>
              <WrapperContainer Container={FlexContainers.FlexRowStart} gap={4}>
                <WrapperContainer Container={FlexContainers.FlexRowStart} gap={16}>
                  <Checkbox
                    id={"generate-certificates"}
                    checked={generateCertificates}
                    onCheck={() => setGenerateCertificates((prev) => !prev)}
                  />
                  <CheckboxLabel for={"generate-certificates"}>
                    {t(strCode.GENERATE_CERTIFICATES_TITLE)}
                  </CheckboxLabel>
                </WrapperContainer>
                <TooltipIcon>{t(strCode.GENERATE_CERTIFICATES_TOOLTIP)}</TooltipIcon>
              </WrapperContainer>
            </>
          )
        );
      }}
    />
  );
};

DeviceBatchCreateModal.propTypes = {
  SuccessImportActions: PropTypes.node,
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default DeviceBatchCreateModal;
